/**
 * Visuel par défaut d'un profil sans photo : un dégradé à deux halos, calculé
 * à partir du nom. Même nom, même visuel, sur tous les écrans et tous les
 * appareils — sans image à stocker ni requête vers un service tiers.
 *
 * Les teintes sont exprimées en OKLCH à clarté bornée : quelle que soit la
 * teinte tirée, les initiales blanches gardent un contraste lisible (une
 * teinte jaune en HSL à clarté égale serait trop claire pour du texte blanc).
 */
/** FNV-1a 32 bits : stable d'un navigateur à l'autre, sans dépendance. */
function hash(seed: string): number {
  let value = 0x811c9dc5;
  for (const char of seed.trim().toLowerCase()) {
    value ^= char.codePointAt(0)!;
    value = Math.imul(value, 0x01000193);
  }
  return value >>> 0;
}

export function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

/** Fond du visuel, posé par la variable `--avatar-art` (règle `.avatar-art`). */
export function avatarArt(seed: string): string {
  const h = hash(seed);
  const base = h % 360;
  const second = (base + 35 + ((h >>> 9) % 70)) % 360;
  const third = (base + 300 - ((h >>> 17) % 60)) % 360;
  // Les halos partent des coins : le centre, où se lisent les initiales, reste sombre.
  const corner = (bits: number): string => `${bits & 1 ? 88 : 12}% ${bits & 2 ? 86 : 14}%`;
  const first = (h >>> 3) & 3;
  // Second halo dans un autre coin que le premier.
  const other = (first + 1 + ((h >>> 5) % 3)) & 3;
  return [
    `radial-gradient(circle at ${corner(first)}, oklch(0.6 0.15 ${second}) 0, transparent 58%)`,
    `radial-gradient(circle at ${corner(other)}, oklch(0.36 0.11 ${third}) 0, transparent 62%)`,
    `linear-gradient(135deg, oklch(0.5 0.14 ${base}), oklch(0.44 0.13 ${second}))`,
  ].join(', ');
}
